import { h } from 'vue';

import { classNames } from '@components/utils';

import type { CSSProperties } from 'vue';

interface DropIndicatorProps {
  dropPosition: -1 | 0 | 1;
  dropLevelOffset: number;
  indent: number;
}

const OFFSET = 4;

export default function DropIndicator(props: DropIndicatorProps) {
  const { dropPosition, dropLevelOffset, indent } = props;

  const startPosition = 'left';
  const endPosition = 'right';
  const style: CSSProperties = {
    [startPosition]: `${-dropLevelOffset * indent + OFFSET}px`,
    [endPosition]: 0
  };
  switch (dropPosition) {
    case -1:
      style.top = `${-3}px`;
      break;
    case 1:
      style.bottom = `${-3}px`;
      break;
    default:
      style.bottom = `${-3}px`;
      style[startPosition] = `${indent + OFFSET}px`;
      break;
  }

  return h('div', { style, class: classNames('cds-tree__drop-indicator') });
}
